export const initState = {
  accountInfo: {},
  token: "",
};
